import { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import BrandLogo from '../components/BrandLogo';
import { authAPI } from '../services/api';
import '../styles/login.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [organizationId, setOrganizationId] = useState('');
  const [organizations, setOrganizations] = useState([]);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await authAPI.login(email, password, organizationId);
      login(res.data);
      const r = res.data?.user?.role || res.data?.role;
      navigate(r === 'student' ? '/student/dashboard' : '/dashboard');
    } catch (err) {
      const choices = err.response?.data?.organizations;
      if (err.response?.status === 409 && Array.isArray(choices) && choices.length) {
        setOrganizations(choices);
        setOrganizationId(choices[0].organizationId);
      }
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-shell">
      <aside className="login-brand" aria-label="VLSI Expert branding">
        <div className="login-brand-inner">
          <BrandLogo size="hero" />
          <p className="login-brand-kicker">VLSI Expert Pvt. Ltd.</p>
          <h1 className="login-brand-title">VLSI Expert</h1>
          <p className="login-brand-subtitle">Student Management System</p>
          <p className="login-brand-copy">
            Training, batches, readiness, and placement — one place for your institute operations.
          </p>
        </div>
      </aside>

      <main className="login-panel">
        <div className="login-panel-card">
          <h2 className="login-panel-heading">Sign in</h2>
          <p className="login-panel-lead">Use your institute email and password to continue.</p>

          <form onSubmit={handleLogin} noValidate>
            <div className="login-field">
              <label htmlFor="login-email">Email</label>
              <input
                id="login-email"
                type="email"
                name="email"
                autoComplete="username"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="login-field">
              <label htmlFor="login-password">Password</label>
              <input
                id="login-password"
                type="password"
                name="password"
                autoComplete="current-password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            {organizations.length > 1 ? (
              <div className="login-field">
                <label htmlFor="login-organization">Organization</label>
                <select
                  id="login-organization"
                  value={organizationId}
                  onChange={(e) => setOrganizationId(e.target.value)}
                >
                  {organizations.map((org) => (
                    <option key={org.organizationId} value={org.organizationId}>
                      {org.name}
                    </option>
                  ))}
                </select>
              </div>
            ) : null}

            {error ? (
              <div className="login-error" role="alert">
                {error}
              </div>
            ) : null}

            <button type="submit" className="login-submit" disabled={loading}>
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>

          <p className="login-footnote">
            Need an account? <Link to="/request-account">Request access</Link>
            <br />
            Authorized users only · VLSI Expert Pvt. Ltd.
          </p>
        </div>
      </main>
    </div>
  );
};

export default LoginPage;
